import React from 'react';
import { Link } from 'react-router-dom'

import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import Auth from '../Auth'

import Nav from './Nav'


class Login extends React.Component {

	constructor(props) {
		super(props);

		this.name = React.createRef();
		this.companyName = React.createRef();
		this.email = React.createRef();
		this.password = React.createRef();

		let query = new URLSearchParams(this.props.location.search);
		// console.log(this.props.location.search);

		this.state = { mode: query.get('mode') || 'signup' };


	}

	handleSubmit = async (event) => {
		event.preventDefault()
		console.log(this.email.current.value, this.password.current.value)

		try {

			this.setState({ error: null })

			if (this.state.mode == 'login') {

				var authenticationDetails = new AuthenticationDetails({ Username: this.email.current.value, Password: this.password.current.value });
				var userData = { Username: this.email.current.value, Pool: Auth.userPool };
				var cognitoUser = new CognitoUser(userData);

				cognitoUser.authenticateUser(authenticationDetails, {
					onSuccess: (result) => {
						var accessToken = result.getAccessToken().getJwtToken();
						console.log('result is ', result);

						var cognitoUser = Auth.userPool.getCurrentUser();
						console.log('cognitoUser', cognitoUser);

						Auth.update(true)
						this.goBack()

					},
					onFailure: (err) => {
						alert(err.message || JSON.stringify(err));
					},
				});

			}
			if (this.state.mode == 'signup') {

				var attributeList = [];
				attributeList.push(new CognitoUserAttribute({ Name: 'email', Value: this.email.current.value, }));
				attributeList.push(new CognitoUserAttribute({ Name: 'name', Value: this.name.current.value, }));
				attributeList.push(new CognitoUserAttribute({ Name: 'custom:CompanyName', Value: this.companyName.current.value, }));

				Auth.userPool.signUp(this.email.current.value, this.password.current.value, attributeList, null, (err, result) => {
					if (err) {
						alert(err.message || JSON.stringify(err));
						return;
					}
					var cognitoUser = result.user;
					console.log('user name is ' + cognitoUser.getUsername());

					var cognitoUser = Auth.userPool.getCurrentUser();
					console.log('cognitoUser', cognitoUser);

					this.setState({ mode: 'login', signupSuccess: true })

					// this.goBack()
				});

			}

			// let { from } = this.props.location.state || { from: { pathname: "/" } };
			// this.props.history.replace(from);

		} catch (e) {
			console.log(e.message || e);
			this.setState({ error: e.message || e })
		}
	}

	goBack() {
		let { from } = this.props.location.state || { from: { pathname: "/" } };
		this.props.history.replace(from);
	}

	switchMode(event, mode) {
		event && event.preventDefault()
		console.log(mode);
		this.setState({ mode: mode })
	}


	render() {
		let inputLabelClass = 'small text-uppercase font-weight-500'
		return (
			<>
				<Nav {...this.props} hideLogin="true" ></Nav>


				<div className="d-flex flex-column justify-content-center align-items-stretch vh-100ish  py-5 px-3">
					{/* <div className="h1 text-center my-5 py-5"><Link to="/" className="text-reset text-decoration-none"><img src="/reconfig-logo.svg" className="logo" /></Link></div> */}

					{this.state.signupSuccess &&
						<div className="text-center">
							<div className="d-inline-block bg-light rounded border p-3 mb-5">
								<div className="font-weight-600">Your account is pending confirmation!</div>
								<div className="small">Please click the link in the confirmation email then log in here</div>
							</div>
						</div>
					}

					<form onSubmit={this.handleSubmit} className=" bg-white shadow rounded-lg max30 p-5">

						{this.state.mode == 'signup' && <div className="h2 text-primary font-weight-600 text-center mb-5 ">Create Your Free Account</div>}
						{this.state.mode == 'login' && <div className="h2 text-primary font-weight-600 text-center mb-5 ">Login to Reconfig</div>}

						{this.state.mode == 'signup' &&
							<>
								<div className="form-group">
									<label htmlFor="email" className={inputLabelClass}>Name</label>
									<input type="name" className="form-control" id="name" ref={this.name} />
								</div>
								<div className="form-group">
									<label htmlFor="companyName" className={inputLabelClass}>Company Name</label>
									<input type="text" className="form-control" id="companyName" ref={this.companyName} />
								</div>
							</>
						}

						<div className="form-group">
							<label htmlFor="email" className={inputLabelClass}>Email address</label>
							<input type="email" className="form-control" id="email" ref={this.email} />
						</div>
						<div className="form-group">
							<label htmlFor="password" className={inputLabelClass}>Password</label>
							<input type="password" className="form-control" id="password" ref={this.password} />
						</div>


						<div className="small text-danger text-center my-4 ">{this.state.error}</div>

						<div className="text-center my-4">
							<button type="submit" className="btn btn-primary text-capitalize px-4">{this.state.mode == 'login' ? 'Log In' : 'Sign Up'}</button>
						</div>

						<div className="text-center">
							{(this.state.mode == 'login' && <a href="" className="small" onClick={(e) => this.switchMode(e, 'signup')}>Sign Up</a>)}
							{(this.state.mode == 'signup' && <a href="" className="small" onClick={(e) => this.switchMode(e, 'login')}>Log In</a>)}
						</div>

					</form>


				</div>
			</>

		)
	}


}

export default Login
